import { getDashboardData } from 'modules/society/actions/dashBoardActions';

export const getPlansViewData = async (societyId, dispatch) => {
  const plansData = await dispatch(getDashboardData(societyId, 'plans'));
  return plansData;
};
